import { useEffect, useState } from "react"

const useMediaQuery = (query: string) => {
  const mediaQuery =
    typeof window !== `undefined`
      ? window.matchMedia?.(query)
      : ({} as MediaQueryList)
  const [matches, setMatches] = useState(mediaQuery?.matches ?? false)
  const handler = (event: MediaQueryListEvent) => {
    setMatches(event.matches)
  }

  useEffect(() => {
    // addEventListener is only support in the last couple of Safari releases
    // so fallback to addListener in case
    if (`addEventListener` in mediaQuery) {
      mediaQuery.addEventListener(`change`, handler)
    } else if (`addListener` in mediaQuery) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore Typescript doesn't keep types for older browsers
      mediaQuery.addListener(handler)
    }

    return () => {
      if (`removeEventListener` in mediaQuery) {
        mediaQuery.removeEventListener(`change`, handler)
      } else if (`removeListener` in mediaQuery) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore Typescript doesn't keep types for older browsers
        mediaQuery.removeListener(handler)
      }
    }
  })

  return matches
}

export default useMediaQuery
